export function trackPageView() {
  // Get current page info
  const pageInfo = {
    page_path: window.location.pathname,
    page_title: document.title,
    page_url: window.location.href,
    referrer: document.referrer,
    // Add custom properties based on your needs
    user_type: window.user ? 'authenticated' : 'anonymous',
    user_id: window.user?.firebase_user_id || null,
    // Add Rails controller/action info if available
    ...(window.pageTrackingData || {})
  };

  // Track the page view with custom properties
  window.mixpanel.track('Page View', pageInfo);
}

// Enhanced page tracking with controller/action info
export function trackRailsPageView(controller: string, action: string, additionalProps: Record<string, any> = {}) {
  const pageInfo = {
    page_path: window.location.pathname,
    page_title: document.title,
    page_url: window.location.href,
    referrer: document.referrer,
    controller: controller,
    action: action,
    user_type: window.user ? 'authenticated' : 'anonymous',
    user_id: window.user?.firebase_user_id || null,
    ...additionalProps
  };

  window.mixpanel.track('Page View', pageInfo);
}